const isValidVRN = (vrn: string): boolean =>
  /(?<Current>^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(?<Prefix>^[A-Z][0-9]{1,3}\s?[A-Z]{3}$)|(?<Suffix>^[A-Z]{3}\s?[0-9]{1,3}[A-Z]$)|(?<DatelessLongNumberPrefix>^[0-9]{1,4}\s?[A-Z]{1,2}$)|(?<DatelessShortNumberPrefix>^[0-9]{1,3}\s?[A-Z]{1,3}$)|(?<DatelessLongNumberSuffix>^[A-Z]{1,2}\s?[0-9]{1,4}$)|(?<DatelessShortNumberSufix>^[A-Z]{1,3}\s?[0-9]{1,3}$)|(?<DatelessNorthernIreland>^[A-Z]{1,3}\s?[0-9]{1,4}$)|(?<DiplomaticPlate>^[0-9]{3}\s?[DX]{1}\s?[0-9]{3}$)/gim.test(
    vrn
  )

export default isValidVRN
